/* Variant B: beweging. Alles valt weg bij prefers-reduced-motion. */

(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  document.documentElement.classList.add('js-motion');
  if (reduce) {
    document.documentElement.classList.add('reduce-motion');
    return;
  }

  // Kop woord voor woord omhoog
  document.querySelectorAll('[data-split]').forEach((el) => {
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((child) => {
        if (child.nodeType === 3) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
            const outer = document.createElement('span');
            outer.className = 'w';
            const inner = document.createElement('span');
            inner.textContent = part;
            inner.style.transitionDelay = `${120 + i++ * 70}ms`;
            outer.appendChild(inner);
            frag.appendChild(outer);
          });
          child.replaceWith(frag);
        } else {
          walk(child);
        }
      });
    };
    walk(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
  });

  // Prijs zakt van adviesprijs naar partijprijs
  const priceEl = document.querySelector('[data-count-from]');
  if (priceEl) {
    const toNumber = (str) => Number((str || '').replace(/[^\d,]/g, '').split(',')[0]);
    const from = toNumber(priceEl.dataset.countFrom);
    const to = toNumber(priceEl.textContent);
    if (from > to && to > 0) {
      const fmt = (n) => `€ ${Math.round(n).toLocaleString('nl-NL')}`;
      const start = performance.now() + 700;
      const dur = 1400;
      priceEl.textContent = fmt(from);
      priceEl.classList.add('is-counting');
      const step = (now) => {
        const t = Math.min(1, Math.max(0, (now - start) / dur));
        const eased = 1 - Math.pow(1 - t, 4);
        priceEl.textContent = fmt(from - (from - to) * eased);
        if (t < 1) requestAnimationFrame(step);
        else { priceEl.classList.remove('is-counting'); priceEl.classList.add('is-landed'); }
      };
      requestAnimationFrame(step);
    }
  }

  // Secties schuiven in beeld, met stagger binnen een groep
  const targets = document.querySelectorAll(
    '[data-reveal], .band__head, .calc__panel, .step, .story__point, .specs__table tr, .faq details, .trust__item, .compare tbody tr, .biz__list li, .form, .closer .h2, .closer p, .closer .btn'
  );
  targets.forEach((el) => {
    el.classList.add('rv');
    const siblings = [...el.parentElement.children].filter((c) => c.classList.contains('rv'));
    el.style.transitionDelay = `${Math.min(siblings.indexOf(el), 8) * 70}ms`;
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  targets.forEach((el) => io.observe(el));

  // Lichtgloed volgt de cursor in de hero, laadpaal kantelt mee
  const hero = document.querySelector('[data-hero]');
  const tilt = document.querySelector('[data-tilt]');
  if (hero && fine) {
    let raf;
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        hero.style.setProperty('--mx', `${x * 100}%`);
        hero.style.setProperty('--my', `${y * 100}%`);
        if (tilt) {
          tilt.style.setProperty('--rx', `${(0.5 - y) * 14}deg`);
          tilt.style.setProperty('--ry', `${(x - 0.5) * 18}deg`);
        }
      });
    });
    hero.addEventListener('pointerleave', () => {
      if (tilt) { tilt.style.setProperty('--rx', '0deg'); tilt.style.setProperty('--ry', '0deg'); }
    });
  }

  // Koopknop trekt licht naar de cursor
  if (fine) {
    document.querySelectorAll('[data-magnetic]').forEach((btn) => {
      btn.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        btn.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.12}px, ${(e.clientY - r.top - r.height / 2) * 0.25}px)`;
      });
      btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
    });
  }

  // Stroomkabel die oplicht terwijl je scrolt
  const wire = document.querySelector('[data-wire]');
  if (wire) {
    const path = wire.querySelector('.wire__live');
    const base = wire.querySelector('.wire__base');
    const spark = wire.querySelector('.wire__spark');
    let len = 0;
    const build = () => {
      const h = document.documentElement.scrollHeight;
      wire.setAttribute('viewBox', `0 0 60 ${h}`);
      wire.style.height = `${h}px`;
      let d = 'M30 0';
      for (let y = 0; y < h; y += 420) {
        d += ` C${y % 840 ? 6 : 54} ${y + 140} ${y % 840 ? 54 : 6} ${y + 280} 30 ${y + 420}`;
      }
      path.setAttribute('d', d);
      base.setAttribute('d', d);
      len = path.getTotalLength();
      path.style.strokeDasharray = len;
      update();
    };
    const update = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 0 ? scrollY / max : 0;
      const drawn = len * Math.min(1, (scrollY + innerHeight * 0.6) / document.documentElement.scrollHeight + p * 0.05);
      path.style.strokeDashoffset = len - drawn;
      const pt = path.getPointAtLength(drawn);
      spark.setAttribute('cx', pt.x);
      spark.setAttribute('cy', pt.y);
    };
    let wireTicking = false;
    addEventListener('scroll', () => {
      if (wireTicking) return;
      wireTicking = true;
      requestAnimationFrame(() => { update(); wireTicking = false; });
    }, { passive: true });
    addEventListener('resize', build);
    addEventListener('load', build);
    build();
  }

  // Rekenaar: getal telt naar de nieuwe uitkomst
  const kmh = document.querySelector('[data-out="kmh"]');
  if (kmh) {
    let shown = Number(kmh.textContent) || 0;
    new MutationObserver(() => {
      const target = Number(kmh.textContent);
      if (!target || target === Math.round(shown) || kmh.dataset.tweening) return;
      const from = shown;
      const t0 = performance.now();
      kmh.dataset.tweening = '1';
      const tick = (now) => {
        const t = Math.min(1, (now - t0) / 500);
        shown = from + (target - from) * (1 - Math.pow(1 - t, 3));
        kmh.textContent = Math.round(shown);
        if (t < 1) requestAnimationFrame(tick);
        else delete kmh.dataset.tweening;
      };
      requestAnimationFrame(tick);
    }).observe(kmh, { childList: true });
  }
})();
